"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var styles_1 = require("@material-ui/core/styles");
var icons_1 = require("../../../styles/config/icons");
var theme_1 = __importDefault(require("../../../styles/theme"));
var makeStyles_1 = __importDefault(require("../../../util/makeStyles"));
/*
 Styling DetailsSection is tricky, because its content is so variable.
 When changing these styles, please make sure that the following properties still hold:

 - Rows with a single line of text have a height of 24px (defaultIconSize).
   Check this for rows with icons and rows without icons.
 - For single-line values, the text should be centered within the row.
 - The first row of the value must be vertically aligned with the label text.
   Check this for single-line values and multi-line values.
 - When the text contains multiple rows, both the label and the avatars are aligned at the top.

*/
var minRowHeight = icons_1.defaultIconSize;
// A single line of text should have height `minHeight` with the text being centered.
// We cannot use `line-height: minHeight`, because this gives the wrong line-height in multi-line texts.
// We also cannot use `align-items: center`, because then multi-line text would not be aligned with the label.
var valueTextVerticalPadding = (minRowHeight - theme_1.default.bodyFontLineHeight) / 2;
exports.default = (0, makeStyles_1.default)(function () {
    return (0, styles_1.createStyles)({
        root: {
            display: 'grid',
            gridTemplateColumns: 'min-content minmax(auto, max-content)',
            gridAutoColumns: 'auto',
            rowGap: 16,
            columnGap: 32,
            alignItems: 'flex-start',
        },
        withBackground: {
            padding: 24,
            backgroundColor: 'white',
            borderRadius: 4,
        },
        labelCell: {
            gridColumn: 1,
            display: 'flex',
            alignItems: 'center',
            minHeight: minRowHeight,
        },
        valueCell: {
            gridColumn: 2,
            display: 'flex',
            flexWrap: 'wrap',
            overflow: 'hidden',
            alignItems: 'center',
            height: '100%',
        },
        editCell: {
            gridColumn: 3,
            display: 'flex',
            marginLeft: -16,
        },
        avatarCell: {
            gridColumn: 3,
            display: 'flex',
            justifySelf: 'end',
        },
        icon: {
            marginRight: 8,
        },
        valueTextWithoutIcon: {
            padding: "".concat(valueTextVerticalPadding, "px 0"),
        },
        textLine: {
            marginBottom: 8,
        },
        tooltip: {
            marginLeft: 4,
        },
    });
});
